export { default as withNotifications } from '@components/hoc/withNotifications/withNotifications';



// WEBPACK FOOTER //
// ./src/components/hoc/withNotifications/index.ts